import { ConnectionStatus } from "components/usernotifications/ConnectionStatus";
import { useAppSettings } from "contexts/AppSettingsContext";
import { useState } from "react";
import { Container, Navbar } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import { BottomNavInfoModal } from "./BottomNavInfoModal";

/**
 * Bottom navigation bar showing application version, info toggle and connection status.
 *
 * @returns A JSX element rendering the fixed-bottom navbar.
 */
export const BottomNav = (): React.ReactElement => {
  const appSettings = useAppSettings();

  const [showInfo, setShowInfo] = useState<boolean>(false);

  return (
    <Navbar
      variant="dark"
      bg="dark"
      style={{ padding: 0 }}
      fixed="bottom"
    >
      <Container fluid>
        <Navbar.Text className="d-flex gap-2 align-items-center">
          <small id="bottomnav-versions">
            {process.env.npm_package_name} {process.env.npm_package_version}
            {" / "}
            {appSettings.backEndVersion}
          </small>
          <InfoCircle
            id="bottomnav-info"
            aria-label="Show information panel"
            onClick={() => setShowInfo(!showInfo)}
          />
          <ConnectionStatus />
        </Navbar.Text>
      </Container>
      <BottomNavInfoModal
        show={showInfo}
        setShow={setShowInfo}
      />
    </Navbar>
  );
};

BottomNav.displayName = "BottomNav";
